import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type AuthState = {
  isAuthenticated: boolean
  userEmail?: string
  /** Cached from Auth0 ID token custom claim https://inflectionmedicine.com/familyMemberId */
  familyMemberId?: string
}

const initialState: AuthState = {
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<{ isAuthenticated: boolean; userEmail?: string }>) {
      state.isAuthenticated = action.payload.isAuthenticated
      state.userEmail = action.payload.userEmail
    },
    setFamilyMemberId(state, action: PayloadAction<string | undefined>) {
      state.familyMemberId = action.payload
    },
    clearAuth(state) {
      state.isAuthenticated = false
      state.userEmail = undefined
      state.familyMemberId = undefined
    },
  },
})

export const { setAuthenticated, setFamilyMemberId, clearAuth } = authSlice.actions
export const selectFamilyMemberId = (state: { auth: AuthState }) => state.auth.familyMemberId
export default authSlice.reducer
